module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_j_erythristic.818324a8.png";